import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation, EventEmitter, OnChanges, SimpleChanges, Input, Output, SimpleChange } from '@angular/core';
import { formatNumber } from '@angular/common';
import { concat, from, of, Subscription, Subject } from 'rxjs';
import { map, switchMap, concatMap, debounceTime, distinctUntilChanged, filter, finalize } from 'rxjs/operators';

import { MenuItem, MessageService, FilterService } from 'primeng/api';
import { Table } from 'primeng/table';
import { saveAs } from 'file-saver';

import { environment } from 'src/environments/environment';
import { round1, round2 } from 'src/app/shared/round';

import { GlobalSettingsData } from 'src/app/shared/global-settings-data'
import { GetglobalsettingsService } from 'src/app/services/getglobalsettings.service'
import { DocumentApiService } from 'src/app/services/document-api.service';
import { Document } from 'src/app/shared/document';
import { DocListEntry } from 'src/app/shared/doc-list-entry';
import { SalesLead, SalesLeadItem } from 'src/app/shared/sales-leads';
import { SalesApiService } from 'src/app/services/sales-api.service';

@Component({
  selector: 'app-edit-sales-lead-items',
  templateUrl: './edit-sales-lead-items.component.html',
  styleUrls: ['./edit-sales-lead-items.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class EditSalesLeadItemsComponent implements OnInit, OnDestroy, OnChanges {

  @Input() salesLeadId: number;
  @Input() showHeader: boolean = true;
  @Input() allowEditControls: boolean = true;

  globalSettinsData: GlobalSettingsData;

  @ViewChild('ptable4') ptable4: Table;

  salesLead: SalesLead;
  salesLeadItems: SalesLeadItem[];
  salesLeadItemsCopy: SalesLeadItem[] = [];
  salesLeadItemsClone: SalesLeadItem[] = [];

  selectedSalesLeadItem: SalesLeadItem;

  salesLeadItemsQuery: Subscription;
  totalSalesLeadItems: number;

  loading: boolean = false;

  private salesLeadItemsSubj$ = new Subject<number>();

  public get paginator(): boolean { return (this.salesLeadItems || []).length > 10; }

  // to store f[string] filters value

  cf4: any = {};

  private docItemQuery: Subscription;
  private diSumQuery: Subscription;
  private diSaveQuery: Subscription;
  private diGroupQuery: Subscription;

  private _productInfoQuery: Subscription;
  private _prodShippedQuery: Subscription;

  typeDeleteConfirmation: boolean = false;
  confirmText: string = 'DELETE 12';
  deleteAllRows: boolean = false;

  allDocItemsChanged: boolean = false;

  editMode: boolean;
  confirmDeleteOn: boolean;

  private storeNameShowRowOptions: string = 'edit-sales-lead-items-table-columns-1';

  showFilterOptions = [
    { name: 'Filter', icon: 'pi pi-filter', value: 1, disabled: false },
  ];

  showFilterValue: number[] = [1];

  public get showFilter(): boolean { return this.showFilterValue.includes(1); }

  public get noItems(): boolean { return ((this.salesLeadItems || []).length < 1); }
  
  public get selection(): boolean { return this.selectedSalesLeadItem ? true : false; }

  public get changes(): boolean { return this.editMode || this.allDocItemsChanged; }

  public allowSave(sl: SalesLeadItem, index: number): boolean {
    //let al = this.salesLeadItems[index];
    //return al && (al.DOCID ? true : false);
    return sl && (sl.DOCID ? true : false);
  }

  @Output() editing: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private salesApi: SalesApiService,
    private messageService: MessageService,
    private docApi: DocumentApiService,
    private globalsettingsservice: GetglobalsettingsService,
    private filterService: FilterService,
  ) { }

  reloadDocContent(event) {
    console.log('*** EditSalesLeadItemsComponent reloadDocContent: ' + JSON.stringify(event))

    if (this.salesLeadId) {
      this.salesLeadItemsSubj$.next(this.salesLeadId);
    }
  }

  saveDiCopy() {
    this.salesLeadItemsCopy = [];
    this.salesLeadItems.forEach(e => this.salesLeadItemsCopy.push({ ...e }));
  }

  restoreDiCopy() {
    this.salesLeadItems = [];
    this.salesLeadItemsCopy.forEach(e => this.salesLeadItems.push({ ...e }));
  }

  docListCalculatedFields(orderList: SalesLeadItem[]) {

    let jn: Date = new Date();
    let td: Date = new Date();
    td.setHours(0, 0, 0, 0);
    let tm: Date = new Date(td);
    tm.setHours(23, 59, 59);

    orderList.forEach((dc: SalesLeadItem) => {
      dc.cloneIndex = 0;

      dc.fs = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.SHIPSUM) < 0.02);

      dc.ps = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.SHIPSUM > 0) && ((dc.DOCSUM - dc.SHIPSUM) > 0.02);

      dc.fp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) < 0.02);

      dc.pp = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && (dc.PAYDSUM > 0) && (Math.abs(dc.DOCSUM - dc.PAYDSUM) > 0.02);

      dc.np = (dc.DOCTYPEID == 1) && (dc.DOCSUM > 0) && ((dc.SHIPSUM - dc.PAYDSUM) > 0.02);

      dc.go = (dc.DOCTYPEID == 1) && (new Date(dc.DOCVALDATE) < jn) && (dc.SHIPSUM == 0) && (dc.PAYDSUM == 0);

      dc.td = (new Date(dc.DOCDATE) > td) && (new Date(dc.DOCDATE) < tm);

      dc.fd = (new Date(dc.DOCDATE) > tm);
    });
  }

  loadSalesLeadItems() {
    this.loading = true;

    this.salesLeadItemsQuery =
      this.salesLeadItemsSubj$
        .pipe(
          concatMap(slId => this.salesApi.getSalesLeadItems(slId).pipe(

            map(data => {
              this.salesLeadItems = data || [];
              this.totalSalesLeadItems = this.salesLeadItems.length;
              this.docListCalculatedFields(this.salesLeadItems);
              environment.production || console.table(this.salesLeadItems);
            }),

            finalize(() => {
              this.loading = false;
            })
          )))
        .subscribe();

    this.salesLeadItemsSubj$.next(this.salesLeadId);
  }

ngOnDestroy(): void {
    console.log('*** EditSalesLeadItemsComponent ngOnDestroy: ')

    if (this.docItemQuery) { this.docItemQuery.unsubscribe(); }

    if (this._productInfoQuery) { this._productInfoQuery.unsubscribe(); }

    if (this._prodShippedQuery) { this._prodShippedQuery.unsubscribe(); }

    if (this.diSaveQuery) { this.diSaveQuery.unsubscribe(); }

    if (this.diSumQuery) { this.diSumQuery.unsubscribe(); }

    if (this.diGroupQuery) { this.diGroupQuery.unsubscribe(); }

  }

  ngOnChanges(changes: SimpleChanges): void {
    //    console.log('*** EditSalesLeadItemsComponent ngOnDestroy: ')
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** EditSalesLeadItemsComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //      console.log('*** EditSalesLeadItemsComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'salesLeadId':
          if (this.globalSettinsData) {
            this.salesLeadItemsSubj$.next(change.currentValue);
          }
          break;
      }
    }
  }

  ngOnInit(): void {
    console.log('*** EditSalesLeadItemsComponent ngOnInit: ')

    this.filterService.register('gtOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value > filter))
    )
    );

    this.filterService.register('GteOrZero', (value: number, filter: number) => (
      ((filter == 0) && (value == 0)) || ((filter > 0) && (value >= filter))
    )
    );

    this.globalSettinsData = this.globalsettingsservice.getGlobalSettings();

    this.loadSalesLeadItems();
  }

  onDocumentSelected(event: Document, sl: SalesLeadItem) {
    console.log('*** EditSalesLeadItemsComponent onDocumentSelected: ' + JSON.stringify(event));

    sl.DOCID = event.DOCID;

  //  this._prodShippedQuery = this.docApi.getDocListEntry(event.DOCID)
  //    .pipe(map(dl => {
  //      sl = { ...sl, ...dl[0]};

  //      let i = this.salesLeadItems.findIndex(e => e.DRID == -2);

  //      this.salesLeadItems[i] = sl;
  //      environment.production || console.table(sl);
  //      environment.production || console.table(this.salesLeadItems[i]);
  //      environment.production || console.table(this.salesLeadItems);
  //    }))
  //    .subscribe();
  }

  onAddRow(event) {
    console.log('*** EditSalesLeadItemsComponent in onAddRow: ' + JSON.stringify(event));

    let newDi: SalesLeadItem = {
      DRID: -2,
      REGID: this.salesLeadId,
      DRNOTE: '',
      DRIDESCRIPTION: '',
      DRIRESPERSON: this.globalSettinsData.mainPersonId,
      DOCID: 0,
      cloneIndex: 0
    };

    this.salesLeadItems = [...this.salesLeadItems, newDi];

    let ppe: SalesLeadItem = this.salesLeadItems.find(e => e.DRID == -2);
    this.onDiRowEditInit(ppe);
    this.ptable4.initRowEdit(ppe);
  }

  onDiRowEditInit(esg: SalesLeadItem) {
    console.log('*** EditSalesLeadItemsComponent in onPpRowEditInit: entry');
    //environment.production || console.table(esg);

    let newCloneIndex: number = 0;

    /*
     * Quite tricky algoritm:
     * Because we can edit simultaneously more than one row in the table.
     * Therefore for every edited row we have to create cloned copy in shadow array [securityGroupsClone]
     * We can't predict the order of starting and ending the edit process
     * 
     * So - Search for max cloneIndex in current table and assign +1 to newly created row copy
     *
     * When row either cancelled or saved - clone index resetted to 0, clone copy deleted from shadow array
     *
     */
    this.salesLeadItems.forEach(pp => { newCloneIndex = Math.max(newCloneIndex, pp.cloneIndex) });

    console.log('*** EditSalesLeadItemsComponent in onPpRowEditInit: newCloneIndex is: ' + newCloneIndex);

    esg.cloneIndex = ++newCloneIndex;
    this.salesLeadItemsClone.push({ ...esg });

    this.editMode = true;
    this.editing.emit(this.editMode);
  }

  onDiRowEditCancel(esg: SalesLeadItem, index: number) {
    console.log('*** EditSalesLeadItemsComponent in onPpRowEditCancel: ' + index);
    //environment.production || console.table(esg);

    let ppid = this.salesLeadItemsClone.findIndex(sg => sg.cloneIndex == esg.cloneIndex);

    if (esg.DRID == -2) {
      // Cancel the newly created record
      // simply delete

      this.salesLeadItems.splice(index, 1);

    } else {
      // Cancel editing of existing record
      // have to reload it from database

      this.salesLeadItems[index] = { ...this.salesLeadItemsClone[ppid] };
      this.salesLeadItems[index].cloneIndex = 0;
    }

    this.salesLeadItemsClone.splice(ppid, 1);

    this.editMode = false;
    this.editing.emit(this.editMode);
  }

  onDiRowEditSave(esg: SalesLeadItem) {
    console.log('*** EditSalesLeadItemsComponent in onDiRowEditSave: ');
    environment.production || console.table(esg);

    let ppid = this.salesLeadItemsClone.findIndex(sg => sg.cloneIndex == esg.cloneIndex);

    this.diSaveQuery =
      // postSalesLeadItemById emits Observable<{ DRID: number }> (Prompt 13-G, the real
      // create-ID shape) while putSalesLeadItemById emits a row count
      // (Observable<number>, Prompt 13-E/13-F interim rule) -- the intermediate
      // map(r => r.DRID) unifies both ternary branches to Observable<number> so the
      // outer .pipe()/.subscribe() below type-checks.
      concat(((esg.DRID == -2) ? this.salesApi.postSalesLeadItemById(esg).pipe(map(r => r.DRID)) : this.salesApi.putSalesLeadItemById(esg))
        .pipe(map(count => {
          console.log('*** EditSalesLeadItemsComponent in onSubscribe to Save: ' + count);

          this.salesLeadItemsClone.splice(ppid, 1);
          esg.cloneIndex = 0;
          this.reloadDocContent(null);
          this.editMode = false;
          this.editing.emit(this.editMode);
        })))
        .subscribe();
  }

  onRemoveAllRow(event) {
    console.log('*** EditSalesLeadItemsComponent in onRemoveRow: ' + JSON.stringify(event));

    this.deleteAllRows = true;
    this.confirmText = 'DELETE ' + this.salesLeadItems.length;
    this.typeDeleteConfirmation = true;
    this.confirmDeleteOn = true;
  }

  onRemoveRow(event) {
    console.log('*** EditSalesLeadItemsComponent in onRemoveRow: ' + JSON.stringify(event));
    this.deleteAllRows = false;
    this.typeDeleteConfirmation = false;
    this.confirmDeleteOn = true;
  }

  onDeleteConfirmation(event) {
    console.log('*** EditSalesLeadItemsComponent onDeleteConfirmation: ' + JSON.stringify(event));
    this.confirmDeleteOn = false;

    if (event) {
      console.log('*** EditSalesLeadItemsComponent onDeleteConfirmation DO DELETE!!! NOW!!!');

      if (this.deleteAllRows) {
        console.log('*** EditSalesLeadItemsComponent onDeleteConfirmation DO DELETE ALL !!! NOW!!! ********** ALL ********');

        from(this.salesLeadItems)
          .pipe(
            concatMap(sl => this.salesApi.deleteSalesLeadItemById(sl)),
            finalize(() => {
              console.log('*** EditSalesLeadItemsComponent onDeleteAllItemsConfirmation: DONE!');
              this.selectedSalesLeadItem = null;
              this.reloadDocContent(null);
            })
          )
          .subscribe();
      } else {
        if (this.selectedSalesLeadItem) {
          this.salesApi.deleteSalesLeadItemById(this.selectedSalesLeadItem)
            .subscribe(() => {
              console.log('*** EditSalesLeadItemsComponent onDeleteConfirmation: DONE!');
              this.selectedSalesLeadItem = null;
              this.reloadDocContent(null);
            });
        }
      }
    }
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });

      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  onExportData() {
    console.log('*** EditSalesLeadItemsComponent onExportData: ')

    import("xlsx").then(xlsx => {

      let exportData: any =
        this.salesLeadItems.map(e => ({

        }));

      const worksheet = xlsx.utils.json_to_sheet(exportData || []);
      const workbook = { Sheets: { document: worksheet }, SheetNames: ['document'] };

      const excelBuffer: any = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });

      this.saveAsExcelFile(excelBuffer, "document");
    });
  }
}
